"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Statuses = void 0;
var Statuses;
(function (Statuses) {
    Statuses["Suspended"] = "suspended";
    Statuses["Loading"] = "loading";
    Statuses["NotFound"] = "notFound";
    Statuses["Showing"] = "showing";
})(Statuses = exports.Statuses || (exports.Statuses = {}));
